// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeleteOfferFromComparisonRequest,
  TDeleteOfferFromComparisonModel,
  IMappers,
  TDeleteOfferFromComparisonResponse_,
  TDeleteOfferFromComparisonResponse,
  TDeleteOfferFromComparisonResponse_1,
  TDeleteOfferFromComparisonResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createDeleteOfferFromComparisonModel(
  parameters: TDeleteOfferFromComparisonRequest,
): TDeleteOfferFromComparisonModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'offers-comparison',
    pathApi: '/v1/delete-offer-from-comparison/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteOfferFromComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteOfferFromComparisonRequest;
}

export async function fetchDeleteOfferFromComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteOfferFromComparisonOptions<TResponse200, TResponse400>): Promise<
  TDeleteOfferFromComparisonResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteOfferFromComparisonModel(parameters),
    config,
  )) as FetchResponse<TDeleteOfferFromComparisonResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDeleteOfferFromComparisonResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TDeleteOfferFromComparisonResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TDeleteOfferFromComparisonResponse;
}
